import { Link } from "react-router-dom";
import type { ComicArticle } from "@/mocks/comics";

interface LatestUpdatesProps {
  comics: ComicArticle[];
}

export default function LatestUpdates({ comics }: LatestUpdatesProps) {
  return (
    <section className="bg-background-100/70 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-display text-foreground-950">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              实时追踪您喜爱的漫画更新
            </p>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-xs text-foreground-500">
              <i className="ri-time-line mr-1"></i>每日更新
            </span>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {comics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group flex gap-3 bg-background-50 rounded-lg p-3 hover:shadow-sm transition-shadow cursor-pointer"
              data-product-shop=""
            >
              <div className="w-20 h-[106px] flex-shrink-0 rounded-md overflow-hidden bg-background-200">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`${comic.title} - 免费韩漫在线阅读`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors leading-snug">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1">
                    {comic.author}
                  </p>
                </div>
                <div>
                  <span className="inline-block px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium whitespace-nowrap">
                    {comic.category}
                  </span>
                  <p className="text-xs text-foreground-400 mt-1">
                    更新至第{comic.chapters.length}话
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}